import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import { Divider } from '@ui/atoms/Divider'
import React from 'react'

export const hr: NodeRenderer = () => <Divider className="my-6" />
